import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		background: theme.mode === "light"
			? "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)"
			: "linear-gradient(135deg, rgba(30,41,59,0.98) 0%, rgba(15,23,42,0.98) 100%)",
		flex: "none",
		borderBottom: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.2)" : "rgba(148,163,184,0.15)"}`,
		height: "62px",
		padding: "0 8px",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "nowrap",
			height: "50px",
			overflow: "hidden",
		},
	},
	backButton: {
		minWidth: "40px",
		width: "40px",
		height: "40px",
		borderRadius: "10px",
		padding: 0,
		marginRight: "4px",
		color: theme.mode === "light" ? "#64748b" : "#94a3b8",
		"&:hover": {
			background: theme.mode === "light" ? "rgba(99,102,241,0.08)" : "rgba(99,102,241,0.15)",
			color: theme.mode === "light" ? "#6366f1" : "#818cf8",
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					className={classes.ticketHeader}
				>
					<Button className={classes.backButton} onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
